module.exports = __webpack_public_path__ + "static/media/ti-tab.eb2302e8.png";